import { TransactionStatus } from '../service-proxies';


export class SettingListDto implements ISettingListDto {
    id!: number;
    allowLongLatDist!: number;
    applicationLimitDays!: number;
    salaryCalcType!: number;
    salaryCalcDay!: number;
    showProjectInThumbApplication!: boolean;
    thumbApplicationDefaultStatus!: TransactionStatus;
    thumbApplicationDefaultStatusName!: string | undefined;
    isSandwichLeaveApplicable!: boolean;
    incrementWaiveDays!: number;
    isLeadersCanApproveApplication!: boolean;
    isEnableCrossCompanyEmployeeListing!: boolean;
    isAvoidLeaveCalcOnHolidays!: boolean;
    isCalcOTAccordingToAttendance!: boolean;
    androidAppLink!: string | undefined;
    iosAppLink!: string | undefined;
    otApplicationLimitDays!: number;
    isLockApproverSelection!: boolean;
    salarySlipType!: number;
    logoUri!: string | undefined;
    logoType!: string | undefined;
    logoPath!: string | undefined;
    countWeeklyOffInSalaryCalc!: boolean | undefined;
    disableTimeEditingForTA!: boolean | undefined;
    letterLogoUri!: string | undefined;
    letterLogoType!: string | undefined;
    letterLogoPath!: string | undefined;
    lastBioDataSyncTime!: Date | undefined;
    dashboardFilterDistance!: number | undefined;
    leaderCanSeeMembersApplication!: boolean | undefined;
    headerSectionImageUri!: string | undefined;
    headerSectionImageType!: string | undefined;
    headerSectionImage!: string | undefined;
    footerSectionImageUri!: string | undefined;
    footerSectionImageType!: string | undefined;
    footerSectionImage!: string | undefined;
    isEnableAutomatedNotification!: boolean | undefined;

    constructor(data?: ISettingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.allowLongLatDist = _data["allowLongLatDist"];
            this.applicationLimitDays = _data["applicationLimitDays"];
            this.salaryCalcType = _data["salaryCalcType"];
            this.salaryCalcDay = _data["salaryCalcDay"];
            this.showProjectInThumbApplication = _data["showProjectInThumbApplication"];
            this.thumbApplicationDefaultStatus = _data["thumbApplicationDefaultStatus"];
            this.thumbApplicationDefaultStatusName = _data["thumbApplicationDefaultStatusName"];
            this.isSandwichLeaveApplicable = _data["isSandwichLeaveApplicable"];
            this.incrementWaiveDays = _data["incrementWaiveDays"];
            this.isLeadersCanApproveApplication = _data["isLeadersCanApproveApplication"];
            this.isEnableCrossCompanyEmployeeListing = _data["isEnableCrossCompanyEmployeeListing"];
            this.isAvoidLeaveCalcOnHolidays = _data["isAvoidLeaveCalcOnHolidays"];
            this.isCalcOTAccordingToAttendance = _data["isCalcOTAccordingToAttendance"];
            this.androidAppLink = _data["androidAppLink"];
            this.iosAppLink = _data["iosAppLink"];
            this.otApplicationLimitDays = _data["otApplicationLimitDays"];
            this.isLockApproverSelection = _data["isLockApproverSelection"];
            this.salarySlipType = _data["salarySlipType"];
            this.logoUri = _data["logoUri"];
            this.logoType = _data["logoType"];
            this.logoPath = _data["logoPath"];
            this.countWeeklyOffInSalaryCalc = _data["countWeeklyOffInSalaryCalc"];
            this.disableTimeEditingForTA = _data["disableTimeEditingForTA"];
            this.letterLogoUri = _data["letterLogoUri"];
            this.letterLogoType = _data["letterLogoType"];
            this.letterLogoPath = _data["letterLogoPath"];
            this.lastBioDataSyncTime = _data["lastBioDataSyncTime"] ? new Date(_data["lastBioDataSyncTime"].toString()) : <any>undefined;
            this.dashboardFilterDistance = _data["dashboardFilterDistance"];
            this.leaderCanSeeMembersApplication = _data["leaderCanSeeMembersApplication"];
            this.headerSectionImageUri = _data["headerSectionImageUri"];
            this.headerSectionImageType = _data["headerSectionImageType"];
            this.headerSectionImage = _data["headerSectionImage"];
            this.footerSectionImageUri = _data["footerSectionImageUri"];
            this.footerSectionImageType = _data["footerSectionImageType"];
            this.footerSectionImage = _data["footerSectionImage"];
            this.isEnableAutomatedNotification = _data["isEnableAutomatedNotification"];
        }
    }

    static fromJS(data: any): SettingListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allowLongLatDist"] = this.allowLongLatDist;
        data["applicationLimitDays"] = this.applicationLimitDays;
        data["salaryCalcType"] = this.salaryCalcType;
        data["salaryCalcDay"] = this.salaryCalcDay;
        data["showProjectInThumbApplication"] = this.showProjectInThumbApplication;
        data["thumbApplicationDefaultStatus"] = this.thumbApplicationDefaultStatus;
        data["thumbApplicationDefaultStatusName"] = this.thumbApplicationDefaultStatusName;
        data["isSandwichLeaveApplicable"] = this.isSandwichLeaveApplicable;
        data["incrementWaiveDays"] = this.incrementWaiveDays;
        data["isLeadersCanApproveApplication"] = this.isLeadersCanApproveApplication;
        data["isEnableCrossCompanyEmployeeListing"] = this.isEnableCrossCompanyEmployeeListing;
        data["isAvoidLeaveCalcOnHolidays"] = this.isAvoidLeaveCalcOnHolidays;
        data["isCalcOTAccordingToAttendance"] = this.isCalcOTAccordingToAttendance;
        data["androidAppLink"] = this.androidAppLink;
        data["iosAppLink"] = this.iosAppLink;
        data["otApplicationLimitDays"] = this.otApplicationLimitDays;
        data["isLockApproverSelection"] = this.isLockApproverSelection;
        data["salarySlipType"] = this.salarySlipType;
        data["logoUri"] = this.logoUri;
        data["logoType"] = this.logoType;
        data["logoPath"] = this.logoPath;
        data["countWeeklyOffInSalaryCalc"] = this.countWeeklyOffInSalaryCalc;
        data["disableTimeEditingForTA"] = this.disableTimeEditingForTA;
        data["letterLogoUri"] = this.letterLogoUri;
        data["letterLogoType"] = this.letterLogoType;
        data["letterLogoPath"] = this.letterLogoPath;
        data["lastBioDataSyncTime"] = this.lastBioDataSyncTime ? this.lastBioDataSyncTime.toISOString() : <any>undefined;
        data["dashboardFilterDistance"] = this.dashboardFilterDistance;
        data["leaderCanSeeMembersApplication"] = this.leaderCanSeeMembersApplication;
        data["headerSectionImageUri"] = this.headerSectionImageUri;
        data["headerSectionImageType"] = this.headerSectionImageType;
        data["headerSectionImage"] = this.headerSectionImage;
        data["footerSectionImageUri"] = this.footerSectionImageUri;
        data["footerSectionImageType"] = this.footerSectionImageType;
        data["footerSectionImage"] = this.footerSectionImage;
        data["isEnableAutomatedNotification"] = this.isEnableAutomatedNotification;
        return data; 
    }
}

export interface ISettingListDto {
    id: number;
    allowLongLatDist: number;
    applicationLimitDays: number;
    salaryCalcType: number;
    salaryCalcDay: number;
    showProjectInThumbApplication: boolean;
    thumbApplicationDefaultStatus: TransactionStatus;
    thumbApplicationDefaultStatusName: string | undefined;
    isSandwichLeaveApplicable: boolean;
    incrementWaiveDays: number;
    isLeadersCanApproveApplication: boolean;
    isEnableCrossCompanyEmployeeListing: boolean;
    isAvoidLeaveCalcOnHolidays: boolean;
    isCalcOTAccordingToAttendance: boolean;
    androidAppLink: string | undefined;
    iosAppLink: string | undefined;
    otApplicationLimitDays: number;
    isLockApproverSelection: boolean;
    salarySlipType: number;
    logoUri: string | undefined;
    logoType: string | undefined;
    logoPath: string | undefined;
    countWeeklyOffInSalaryCalc: boolean | undefined;
    disableTimeEditingForTA: boolean | undefined;
    letterLogoUri: string | undefined;
    letterLogoType: string | undefined;
    letterLogoPath: string | undefined;
    lastBioDataSyncTime: Date | undefined;
    dashboardFilterDistance: number | undefined;
    leaderCanSeeMembersApplication: boolean | undefined;
    headerSectionImageUri: string | undefined;
    headerSectionImageType: string | undefined;
    headerSectionImage: string | undefined;
    footerSectionImageUri: string | undefined;
    footerSectionImageType: string | undefined;
    footerSectionImage: string | undefined;
    isEnableAutomatedNotification: boolean | undefined;
}

